import {Page, Button, Card, Text, Layout} from "@shopify/polaris";
import React, {useEffect, useState} from "react";
import {Redirect} from "@shopify/app-bridge/actions";
import Http from "../../Lib/Http";
import Stepper from "./Stepper"
import PageDivider from "../../components/PageDivider";
import {Plan} from "../../types";
import Alert from "../../Lib/Alert";
import {useLocation} from "react-router-dom";
import {useGoTo} from "@admin/Lib/useGoTo";
import CriticalError from "@admin/components/CriticalError";

function Plan() {
    const [baseURL, setBaseURL] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [legacy, setLegacy] = useState(false);
    const [upgrade, setUpgrade] = useState(false);
    const [freePlan, setFreePlan] = useState<Plan | null>(null);
    const [paidPlan, setPaidPlan] = useState<Plan | null>(null);
    const location = useLocation();
    const goTo = useGoTo();
    const [error, setError] = useState(false);

    const next = () => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app/wizard/2');
    }

    const switchPlan = (planID :number) => {
        setLoading(true) ;
        setError(false);
        Http.get(`/app/api/v1/billing/plan/switch/start/${planID}`).then((res) => {
            //console.log(res.data)
            if(!res.data.free) {
               // window.parent.location.href = res.data.redirect;
                  let redirect = Redirect.create(window.app);
                  redirect.dispatch(Redirect.Action.REMOTE, res.data.redirect);
            } else {
                let redirect = Redirect.create(window.app);
                redirect.dispatch(Redirect.Action.APP, '/app/wizard/3');
            }

        }).catch((err) => {
             setError(true);
        });
    }



    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const hasUpgrade = queryParams.get('upgrade');

        if (hasUpgrade && hasUpgrade == '1') {
             setUpgrade(true);
        }

        getPlans();
    }, []);


    const getShops = () => {
        setLoading(true) ;

        Http.get(`/app/api/v1/shop.json`)
            .then((response) => {
                let shop = response.data.shop
                setLegacy( shop.legacy);
                setLoading(false) ;
                console.log(shop);
                console.log('shop.legacy');

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false) ;
            });
    };


    const getPlans = () => {
        setLoading(true) ;

        Http.get(`/app/api/v1/billing/plans`)
            .then((response) => {
                setFreePlan(response.data.free)
                setPaidPlan(response.data.paid)
                setLoading(false) ;
                getShops();
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false) ;
            });
    };


    return (
        <Page title={upgrade ? 'Upgrade to premium' : undefined} backAction={{
            content: 'Home', onAction() {
                goTo('')
            }
        }}>
            {error &&
                <Layout>
                    <Layout.Section>
                        <CriticalError  onDismiss={() => {setError(false)}}  showAlert={error} title={'Error selecting a plan'} />
                    </Layout.Section>
                </Layout>
            }
            <div>
                {!upgrade &&
                    <Stepper currentStep={1}/>
                }
                <Card>
                    <div className="nbis-center mb-10 mt-20">
                        <Text variant="headingLg" as="h5">
                            Choose your Size Guides Plan
                        </Text>
                    </div>
                    <PageDivider title={'Plans'}/>

                    <table className="Polaris-DataTable__Table nbis-zebra-table">
                        <thead>
                        <tr className="nbis-bg-white">
                            <th style={{width: '24%', background: '#FFFFFF'}}></th>
                            <th style={{width: '15%', background: '#FFFFFF'}}></th>
                            <th style={{width: '15%', background: '#FFFFFF'}}>
                                <span style={{color: 'rgb(67, 127, 236)'}}>MOST POPULAR</span>
                            </th>
                        </tr>
                        <tr className="nbis-bg-white">
                            <th style={{width: '24%'}}>
                                <div style={{padding: '10px'}}>
                                    <p>Select the plan best suited for your needs</p>
                                </div>
                            </th>
                            <th className="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-top0"
                                style={{width: '15%'}}>
                                <div style={{textAlign: 'center'}}>
                                    <p className="Polaris-DisplayText Polaris-DisplayText--sizeSmall NBIS-Wizard__Heading_regular">Basic
                                        Plan</p>
                                    <span className="Polaris-TextStyle--variationStrong">Free</span>
                                    <div className="nbis-plan-btn-area">
                                        {freePlan &&
                                            <Button onClick={() => switchPlan(freePlan.id)}
                                                    disabled={legacy}>
                                                Select Plan
                                            </Button>
                                        }
                                    </div>
                                </div>
                            </th>
                            <th className="nbis-highligted-cell-top2 Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-top1"
                                style={{width: '15%'}}>
                                <div style={{textAlign: 'center'}}>
                                    <p className="Polaris-DisplayText Polaris-DisplayText--sizeSmall NBIS-Wizard__Heading_regular">Premium
                                        Plan</p><span
                                    className="Polaris-TextStyle--variationStrong">$4.99</span><br/><small><span
                                    className="Polaris-TextStyle--variationStrong">per month</span></small>
                                    <div className="nbis-plan-btn-area">
                                        {paidPlan &&
                                            <Button onClick={() => switchPlan(paidPlan.id)}>
                                                Select Plan
                                            </Button>
                                        }
                                    </div>
                                </div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{width: '24%'}}>Trial period
                            </td>
                            <td className="Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides0"
                                style={{width: '15%'}}>N/A
                            </td>
                            <td className="Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides0 nbis-highligted-cell-sides2"
                                style={{width: '15'}}><strong>7 days</strong>
                            </td>
                        </tr>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{width: '24%'}}>Max number of
                                charts
                            </td>
                            <td className="Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides0"
                                style={{width: '15%'}}>3
                            </td>
                            <td className="Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides0 nbis-highligted-cell-sides2"
                                style={{width: '15'}}>Unlimited
                            </td>
                        </tr>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{width: '24'}}>3 display methods
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="Polaris-DataTable__Cell nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1 nbis-center nbis-highligted-cell-sides2"
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr className="">
                            <td className="Polaris-DataTable__Cell
                                                Polaris-DataTable__Cell--verticalAlignTop
                                                Polaris-DataTable__Cell--header " style={{width: '24'}}>
                                <p>Add text to charts</p>
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="nbis-center nbis-highligted-cell-sides2 Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1"
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                                Polaris-DataTable__Cell--verticalAlignTop
                                                Polaris-DataTable__Cell--header " style={{width: '24'}}>
                                <p>Preset chart templates</p>
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="nbis-center nbis-highligted-cell-sides2 Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1"
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr>
                            <td className="nbis-center  Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{background: '#fff'}}>

                                <div className="nbis3-divder__container"><span className="nbis3-divder__text">New Features</span>
                                </div>

                            </td>
                            <td className="nbis-center Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{background: '#fff'}}>

                                <div className="nbis3-divder__container"></div>
                            </td>
                            <td className="nbis-center nbis-highligted-cell-sides2 Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{background: '#fff'}}>

                                <div className="nbis3-divder__container"></div>
                            </td>
                        </tr>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{width: '24'}}>Import and/or
                                exports
                                charts
                            </td>
                            <td className="Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides0"
                                style={{width: '15'}}>❌
                            </td>
                            <td className="nbis-highligted-cell-sides2 Polaris-DataTable__Cell  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-center nbis-highligted-cell-sides1"
                                style={{width: '15'}}>✅
                            </td>
                        </tr>
                        <tr>
                            <td className="Polaris-DataTable__Cell
                                            Polaris-DataTable__Cell--verticalAlignTop
                                            Polaris-DataTable__Cell--header " style={{width: '24'}}>Add icon to
                                button/link
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center  Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ❌
                            </td>
                            <td className="nbis-highligted-cell-sides2 Polaris-DataTable__Cell nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1 nbis-center "
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr className="">
                            <td className="Polaris-DataTable__Cell
                                                Polaris-DataTable__Cell--verticalAlignTop
                                                Polaris-DataTable__Cell--header " style={{width: '24'}}>
                                <p>"Powered by ESC" watermark on charts</p>
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="nbis-highligted-cell-sides2 Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1"
                                style={{width: '15'}}>
                                ❌
                            </td>
                        </tr>
                        <tr className="">
                            <td className="Polaris-DataTable__Cell
                                                Polaris-DataTable__Cell--verticalAlignTop
                                                Polaris-DataTable__Cell--header " style={{width: '24'}}>
                                <p>Mobile responsiveness</p>
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="nbis-highligted-cell-sides2 Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1"
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr className="">
                            <td className="Polaris-DataTable__Cell
                                                Polaris-DataTable__Cell--verticalAlignTop
                                                Polaris-DataTable__Cell--header " style={{width: '24'}}>
                                <p>Add images</p>
                            </td>
                            <td className="Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides0"
                                style={{width: '15'}}>
                                ✅
                            </td>
                            <td className="nbis-highligted-cell-sides2 Polaris-DataTable__Cell  nbis-center Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-sides1"
                                style={{width: '15'}}>
                                ✅
                            </td>
                        </tr>
                        <tr className="nbis-bg-white">
                            <th style={{width: '24%', background: '#FFFFFF'}}>
                            </th>
                            <th className="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-top0"
                                style={{width: '15%', background: '#FFFFFF'}}>
                                <div style={{textAlign: 'center'}}>
                                    <span className="Polaris-TextStyle--variationStrong">Free</span>
                                    <div className="nbis-plan-btn-area">
                                        {freePlan &&
                                            <Button onClick={() => switchPlan(freePlan.id)}
                                                    disabled={legacy}>
                                                Select Plan
                                            </Button>
                                        }
                                    </div>
                                </div>
                            </th>
                            <th className="nbis-highligted-cell-base2 Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header nbis-highligted-cell-top1"
                                style={{width: '15%', background: '#FFFFFF', borderBottom: '4px solid #437FEC'}}>
                                <div style={{textAlign: 'center'}}>
                                    <span className="Polaris-TextStyle--variationStrong">$4.99</span><br/><small><span
                                    className="Polaris-TextStyle--variationStrong">per month</span></small>
                                    <div className="nbis-plan-btn-area">
                                        {paidPlan &&
                                            <Button onClick={() => switchPlan(paidPlan.id)}>
                                                Select Plan
                                            </Button>
                                        }
                                    </div>
                                </div>
                            </th>
                        </tr>

                        </tbody>
                    </table>
                </Card>
            </div>
            <div style={{paddingBottom: '25px'}}></div>
        </Page>
    );
}

export default Plan;
